import { upload } from "@vercel/blob/client";

// Upload direct navigateur → Vercel Blob, contourne la limite de 4,5 Mo des
// Vercel Functions (le fichier ne transite jamais par notre serveur).
// Auth via clientPayload (le JWT MyAlfa) : @vercel/blob/client `upload()` ne
// sait pas envoyer l'en-tête Authorization — voir
// backend-myalfa/config/blobConfig.js (createBlobUploadTokenHandler) pour la
// vérification côté serveur.
//
// onProgress reçoit {loaded, total, percentage} à chaque avancée de l'envoi
// — utile pour informer l'utilisateur sur les gros fichiers, qui peuvent
// prendre plusieurs secondes/minutes selon la taille et la connexion.
export async function uploadFileToBlob(file, handleUploadUrl, onProgress) {
  const blob = await upload(file.name, file, {
    access: "public",
    handleUploadUrl,
    clientPayload: localStorage.getItem("token"),
    onUploadProgress: onProgress,
  });
  return blob.url;
}
